import WidgetItemId    from "./WidgetItemId";
import WidgetItemTitle from "./WidgetItemTitle";
import WidgetItemValue from "./WidgetItemValue";

class WidgetItem {
  constructor(
    private readonly _id: WidgetItemId = new WidgetItemId(),
    private readonly _title: WidgetItemTitle = new WidgetItemTitle(),
    private readonly _value: WidgetItemValue = new WidgetItemValue()
  ) {
  }

  get id() {
    return this._id;
  }

  get title() {
    return this._title;
  }

  get value() {
    return this._value;
  }
}

export default WidgetItem;
